var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-16 mx-auto my-2"},[_c('div',{staticClass:"loader ease-linear rounded-full border-4 border-primary-lighter h-16 w-16"})])}]

export { render, staticRenderFns }